import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { formatPhone } from './utils';

import './contacts-info.scss';

class ContactsInfo extends PureComponent {
  render() {
    const {
      title,
      address,
      phone,
      email
    } = this.props.content;

    return (
      <div className="contacts-info">
        <h2 dangerouslySetInnerHTML={{ __html: title }} />

        <div className="contacts-info-group">
          <p dangerouslySetInnerHTML={{ __html: address }}/>
        </div>

        <div className="contacts-info-group">
          <a
            href={`tel:${formatPhone(phone)}`}
            dangerouslySetInnerHTML={{ __html: phone }}
          />
        </div>

        {/* <div className="contacts-info-group">
          <div className="contacts-info-label">Бесплатная линия для инвесторов:</div>
          <a
            href={`tel:${formatPhone(phone_investors)}`}
            dangerouslySetInnerHTML={{ __html: phone_investors }}
          />
        </div> */}

        <div className="contacts-info-group">
          <a
            href={`mailto:${email}`}
            dangerouslySetInnerHTML={{ __html: email }}
          />
        </div>
      </div>
    );
  }
}

ContactsInfo.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    address: PropTypes.string,
    phone: PropTypes.string,
    phone_investors: PropTypes.string,
    email: PropTypes.string
  })
};

export default ContactsInfo;



// WEBPACK FOOTER //
// ./src/components/Contacts/ContactsInfo.js